import React,{useState,useEffect} from 'react'
import {Form,Col} from 'react-bootstrap'
function YesNoDropExtra(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const [disabled_extra,setDisabled_extra] = useState(true)
    const [used,setUsed] = useState(false)
    const [value2,setVal2] = useState(props.val!=null?props.val[props.name+'_relatives_degree']:"")
    const [value3,setVal3] = useState(props.val!=null?props.val[props.name+'_relatives_degree_relative']:"")
    let  defEvent = {}
    defEvent.target = {name:props.name+'_relatives_degree',value:""}
        defEvent.name = props.name+'_relatives_degree'
        defEvent.value = ""
    const handleChange = (event) =>{
        
        setVal(event.target.value)
        if(event.target.value =='Yes'){
            setUsed(true)
        }
        props.handler(event)
        
    }
    const handleSecondInputChnage = (event) =>{
        setVal2(event.target.value)
        props.handler(event)
    }
    const handleRelatives = (event)=>{
        setVal3(event.target.value)
        props.handler(event)
    }
    useEffect(()=>{
        if( value ==='Yes'){
            setDisabled_extra(false)
        }
        else if ( value==='No' && used ){
            setDisabled_extra(true)
            
            setVal2("")
            props.handler(defEvent)
        }
      
    },[value])
    return(
        
        <>
        <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control as={"select"} name={props.name}  onChange={handleChange} value={value} disabled={disabled}>

                <option></option>
                <option>Yes</option>
                <option>No</option>
                <option>N/A</option>
                

            </Form.Control>
        </Form.Group>
            <Form.Group as={Col}>
            <Form.Label>Degree of relationship</Form.Label> 
            <Form.Control as={"select"} name={props.name+'_relatives_degree'}  onChange={handleSecondInputChnage} value={value2} disabled={disabled_extra}>

                <option></option>
                <option>First degree relatives</option>
                <option> Second degree relatives</option>
                <option> Third degree relatives</option>
                

            </Form.Control>
        </Form.Group>
        <Form.Group as={Col}>
            <Form.Label>Relative</Form.Label>
            <Form.Control name={props.name+'_relatives_degree'+"_relative"}  onChange={handleRelatives} value={value3}disabled={disabled_extra}/>
        </Form.Group>
        </>
    )
}
YesNoDropExtra.defaultProps = {
    name:"",
    title:"",
    data:null
    
}
function YesNoDropExtra4(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const [disabled_extra,setDisabled_extra] = useState(true)
    const [used,setUsed] = useState(false)
    const [value2,setVal2] = useState(props.val!=null?props.val[props.name+'_relatives_degree']:"")
    const [value3,setVal3] = useState(props.val!=null?props.val[props.name+'_relatives_degree_relative']:"")
    const [value4,setVal4] = useState(props.val!=null?props.val[props.name+'_disease']:"")

    let  defEvent = {}
    defEvent.target = {name:props.name+'_relatives_degree',value:""}
    defEvent.name = props.name+'_relatives_degree'
    defEvent.value = ""
    const handleChange = (event) =>{

        setVal(event.target.value)
        if(event.target.value =='Yes'){
            setUsed(true)
        }
        props.handler(event)

    }
    const handleSecondInputChnage = (event) =>{
        setVal2(event.target.value)
        props.handler(event)
    }
    const handleRelatives = (event)=>{
        setVal3(event.target.value)
        props.handler(event)
    }
    const handleFourthInputChnage = (event) =>{
        setVal4(event.target.value)
        props.handler(event)
    }
    useEffect(()=>{
        if( value ==='Yes'){
            setDisabled_extra(false)
        }
        else if ( value==='No' && used ){
            setDisabled_extra(true)

            setVal2("")
            props.handler(defEvent)
        }

    },[value])
    return(

        <>
            <Form.Group as={Col}>
                <Form.Label>{props.title}</Form.Label>
                <Form.Control as={"select"} name={props.name}  onChange={handleChange} value={value} disabled={disabled}>

                    <option></option>
                    <option>Yes</option>
                    <option>No</option>
                    <option>N/A</option>


                </Form.Control>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>Degree of relationship</Form.Label>
                <Form.Control as={"select"} name={props.name+'_relatives_degree'}  onChange={handleSecondInputChnage} value={value2} disabled={disabled_extra}>

                    <option></option>
                    <option>First degree relatives</option>
                    <option> Second degree relatives</option>
                    <option> Third degree relatives</option>


                </Form.Control>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>Relative</Form.Label>
                <Form.Control name={props.name+'_relatives_degree'+"_relative"}  onChange={handleRelatives} value={value3}disabled={disabled_extra}/>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>Neurological Disease</Form.Label>
                <Form.Control name={props.name+'_disease'}  onChange={handleFourthInputChnage} value={value4} disabled={disabled_extra}/>
            </Form.Group>
        </>
    )
}
YesNoDropExtra4.defaultProps = {
    name:"",
    title:"",
    data:null

}
// export default YesNoDropExtra
export {
    YesNoDropExtra4,
    YesNoDropExtra
}